import { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { WebsiteDayStats } from '../../types';
import { formatDateLabel } from '../../lib/metrics';

interface WebsiteTrafficChartProps {
  stats: WebsiteDayStats[];
}

export function WebsiteTrafficChart({ stats }: WebsiteTrafficChartProps) {
  const data = useMemo(() => {
    return [...stats]
      .sort((a, b) => a.date.localeCompare(b.date))
      .map(d => ({
        date: formatDateLabel(d.date),
        views: d.total,
      }));
  }, [stats]);

  return (
    <div className="chart-card">
      <h3>Website Pageviews</h3>
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="date" fontSize={11} tick={{ fill: '#6b7280' }} />
          <YAxis fontSize={11} tick={{ fill: '#6b7280' }} allowDecimals={false} />
          <Tooltip />
          <Bar dataKey="views" name="Pageviews" fill="#8b5cf6" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
